import { Environments } from '@innovyze/lib_get_service';

const config: any = {
  // [Environments.LOCAL]: {
  //   w3fAgentServer: 'http://localhost',
  // },
};

export const apiEnv =
  (localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
